module.exports = __webpack_public_path__ + "img/hannah.a3bea7c8.webp";